import { BookingDetailSidePanelProfile } from "PFApp/booking/parts/overview/detail_view/booking_detail/booking_detail_side_panel_context/booking_detail_side_panel_context.types";
import { isAdmin, mapProfileToBasicProfile } from "PFCore/helpers/profile";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { fetchProfile as fetchProfileAsAdmin } from "PFCore/services/admin/profiles/fetch_profile";
import { fetchProfile as fetchUserProfile } from "PFCore/services/profile";
import { PermissionRule } from "PFTypes";
import { Dispatch, SetStateAction, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useLocation } from "react-router";

import { BookingFormValues } from "../booking_form_provider";

const WORKFORCE_MEMBER_LOADING = "workforce-member-loading";

type UseInitialWorkforceMember = {
  profileId?: number;
  suspendedProfileDetails?: BookingDetailSidePanelProfile;
  loadingState: Record<string, boolean>;
  setLoadingState: Dispatch<SetStateAction<Record<string, boolean>>>;
};
type UseInitialWorkforceMembeReturn = { loading: boolean };

export const useInitialWorkforceMember = ({
  profileId,
  suspendedProfileDetails,
  loadingState,
  setLoadingState
}: UseInitialWorkforceMember): UseInitialWorkforceMembeReturn => {
  const { data: currentProfile } = useCurrentProfile();

  const { pathname } = useLocation();
  const isAdminPage = pathname.startsWith("/admin");
  const fetchProfile = isAdmin(currentProfile) && isAdminPage ? fetchProfileAsAdmin : fetchUserProfile;
  const isBookingResourcer = useIsCurrentUserPermittedTo(PermissionRule.BookingResourcer);

  const { setValue } = useFormContext<BookingFormValues>();
  const workforceMember = useWatch<BookingFormValues>({ name: "workforceMember" });

  useEffect(() => {
    const fetchPreFilledProfile = async (profileId) => {
      setLoadingState((prev) => ({ ...prev, [WORKFORCE_MEMBER_LOADING]: true }));
      const profileResponse = await fetchProfile(profileId);
      setValue("workforceMember", mapProfileToBasicProfile(profileResponse), { shouldValidate: true });
      setLoadingState((prev) => ({ ...prev, [WORKFORCE_MEMBER_LOADING]: false }));
    };

    if (!isBookingResourcer && !workforceMember) {
      fetchPreFilledProfile(currentProfile.id);
      return;
    }

    if (!profileId || !!workforceMember) {
      return;
    }

    if (suspendedProfileDetails) {
      setValue("workforceMember", suspendedProfileDetails, { shouldValidate: true });
    } else {
      fetchPreFilledProfile(profileId);
    }
  }, [profileId, isBookingResourcer, suspendedProfileDetails]);

  return { loading: loadingState[WORKFORCE_MEMBER_LOADING] };
};
